module.exports = __webpack_public_path__ + "img/vestuario.b63ae56a.svg";